'use client';
import { jsx } from "react/jsx-runtime";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { cn } from "@tameeni/shared-logic";
import { LazyMotion, domAnimation, AnimatePresence, m } from "framer-motion";
import * as React from "react";
const Collapsible = CollapsiblePrimitive.Root;
const CollapsibleTrigger = React.forwardRef(({ children, className, ...props }, ref) => /* @__PURE__ */ jsx(
  CollapsiblePrimitive.CollapsibleTrigger,
  {
    className: cn("cursor-pointer", className),
    ref,
    ...props,
    children
  }
));
CollapsibleTrigger.displayName = "CollapsibleTrigger";
const CollapsibleContent = React.forwardRef(({ children, ...props }, ref) => /* @__PURE__ */ jsx(LazyMotion, { features: domAnimation, children: /* @__PURE__ */ jsx(AnimatePresence, { children: /* @__PURE__ */ jsx(CollapsiblePrimitive.Content, { asChild: true, ...props, children: /* @__PURE__ */ jsx(
  m.div,
  {
    ref,
    initial: { height: 0, opacity: 0 },
    animate: {
      height: "auto",
      opacity: 1,
      transition: {
        height: { duration: 0.3, ease: "easeInOut" },
        opacity: { duration: 0.2, delay: 0.1 }
      }
    },
    exit: {
      height: 0,
      opacity: 0,
      transition: {
        height: { duration: 0.3, ease: "easeInOut" },
        opacity: { duration: 0.2 }
      }
    },
    children
  }
) }) }) }));
CollapsibleContent.displayName = "CollapsibleContent";
export {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger
};
